import PageLayout from '../components/global/PageLayout';
import VideoLibrary from '../components/learn/VideoLibrary';
import useGetOnboarding from '../hooks/businesses/useGetOnboarding';
import { LEARN_IS_HIDDEN } from '../constants/learn';

export default function LearnPage() {
  // The library covers setting a shop up, so it has the setup guide's audience.
  const { isEnabled } = useGetOnboarding();

  return (
    <PageLayout
      headerIsHidden
      withoutChildContainer
      guard={{ isAllowed: isEnabled && !LEARN_IS_HIDDEN }}>
      <VideoLibrary />
    </PageLayout>
  );
}
